import React, { Component } from 'react';
import APIManager from '../services/api-manager';
import ErrorBoundary from './error/error-boundary';

export default class CruiseShipSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            cruiseLine: null,
            cruiseShips: []
        }

        this.apiManager = new APIManager();
    }

    handleError = () => {}

    handleCruiseShips = data => {
        this.setState({ cruiseShips: data, loading: false });
    }

    fetchCruiseShips = lineId => {
        this.apiManager.getCruiseShipsByLineId(lineId, this.handleCruiseShips, this.handleError);
    }

    handleCruiseShipChange = e => {
        e.preventDefault();

        const cruiseShip = parseInt(e.target.value);
        const url = this.state.cruiseShips.filter(ship => ship.id === cruiseShip);

        if (url) window.location.href = url[0].url;
    }

    handleCruiseLineChange = e => {
        e.preventDefault();

        const cruiseLine = parseInt(e.target.value);
        if (cruiseLine === this.state.cruiseLine) return false;
        if (cruiseLine === 0) return this.setState({ cruiseShips: [] });

        this.setState({ cruiseLine, cruiseShips: [], loading: true });
        if (cruiseLine) return this.fetchCruiseShips(cruiseLine);
    }

    renderOption = ({ id, title }) => <option value={id}>{title}</option>;

    renderCruiseLines = cruiseLines => (
        <select className="m-0" onChange={this.handleCruiseLineChange}>
            <option value="0">Please select a cruise line...</option>
            {cruiseLines.map(line => this.renderOption(line))}
        </select>
    )

    renderCruiseShips = () => (
        <select className="m-0" disabled={this.state.cruiseShips.length < 1} onChange={this.handleCruiseShipChange}>
            <option value="0">Please select a cruise ship...</option>
            {this.state.cruiseShips.map(ship => this.renderOption(ship))}
        </select>
    )

    renderLoading = () => {
        if (!this.state.loading) return <></>;

        return (
            <div className="ship-search-loader">
                <div className="loader loader--sm" />
            </div>
        )
    }

    render = () => (<>
        <h2 className="h3 text-center">{this.props.title}</h2>
        <div className="row mt-5">
            <ErrorBoundary>
                <div className="small-12 large-6 columns mb-3">
                    {this.renderCruiseLines(this.props.cruiseLines)}
                </div>
                <div className="small-12 large-6 columns position-relative">
                    {this.renderCruiseShips()}
                    {this.renderLoading()}
                </div>
            </ErrorBoundary>
        </div>
    </>)
}